import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { ReactComponent as UpperArrow } from "assets/images/icons/upper-arrow.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import CreditCardIcon from "assets/images/icons/components/CreditCardIcon";

import * as globalUtils from "../../../../../../helpers/utils";
import { Button } from "primereact/button";
import StyleWrapper from "./style";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useDispatch } from "react-redux";
import { updateLoading } from "redux/actions/commonActions";
import { getCustomerDetails } from "../../../../services";
import { removeDriver, updateLocalDriver } from "redux/actions/motorActions";
import DriverCard from "./driverCard";
import { getDriverDetailsPolicy } from "services/motorRetailService";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";

const Drivers = (props) => {
  const [opened, setOpened] = useState(true);
  const [showAddDriver, setShowAddDriver] = useState(false);
  const [driverToEdit, setDriverToEdit] = useState();
  const [genderName, setGenderName] = useState("");
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [driversList, setDriversList] = useState([...props?.drivers]);
  const toast = useRef(null);
  const { businessLine } = useParams()

  useEffect(() => {
    setDriversList([...props?.drivers]);
  }, [props?.drivers]);

  const handleDriverRemove = (driver) => {
    let DRIVERS = [...driversList];
    DRIVERS = DRIVERS.filter((d) => d.IDNO !== driver.IDNO);
    setDriversList([...DRIVERS]);
    dispatch(removeDriver(driver));
    props.loadGetProposal();
  };

  const handleDriverEdit = (code, id) => {
    const DRIVERS = [...driversList];
    DRIVERS.forEach((d) => {
      if (d.IDNO === id) {
        d.genderCode = code;
        d.genderName = code === "1" ? "Male" : "Female";
        dispatch(updateLocalDriver(d));
        return;
      }
    });

    setDriversList([...DRIVERS]);
  };

  const formik = useFormik({
    initialValues: {
      nationalId: "",
      yob: "",
      mob:"",
      vehicle: props.vehicle,
    },
    validate: (data) => {
      let errors = {};

      if (!data.nationalId) {
        errors.nationalId = t("TP-claim.home-nationalId");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.nationalId)) {
        errors.nationalId = t("TP-claim.home-nationalId-valid");
      }

      if (!data.yob) {
        errors.yob = t("TP-claim.home-yob");
      }
      if (!data.mob) {
        errors.mob = t("motor_person.month_birth");
      }
      return errors;
    },

    onSubmit: (data) => {
      dispatch(updateLoading(true));
      getDriverDetailsPolicy(data, businessLine)
        .then((response) => {
          if (response && response.resultCode && response.resultCode === "V") {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: response.resultMessage,
              life: 6000,
            });
          } else {
            dispatch(
              updateLocalDriver({
                ...data,
                ...response,
                vehicle: props.vehicle,
              })
            );
            formik.setFieldValue("nationalId", "");
            formik.setFieldValue("yob", "select");
            formik.setFieldValue("mob", "select");
            props.loadGetProposal();
          }
        })
        .catch((e) => { })
        .finally((e) => {
          dispatch(updateLoading(false));
        });
    },
  });
  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };
  const getYobList = () => {
    return globalUtils.isSaudi(formik.values.nationalId)
      ? globalUtils.getHijriYearOfBirthList()
      : globalUtils.getGregYearOfBirthList();
  };
  const numbersTemplate = (option, props) => {
    if (option) {
      return <div className="numbers_drop">{option.label}</div>;
    }
    return <span>{props.placeholder}</span>;
  };

  return (
    <StyleWrapper businessColor={props.businessColor}>
      <Toast ref={toast} />
      <div
        onClick={() => setOpened(!opened)}
        className="accordion-header d-flex justify-content-between align-items-center"
      >
        <h5 className="fm-bliss2-bold">{t("MotorEn.Drivers")}</h5>
        <div className="Icon-Div">
          {opened ? (
            <i className="pi pi-chevron-up accordianIcon up-acc"></i>
          ) : (
            <i className="pi pi-chevron-down accordianIcon down-acc"></i>
          )}
        </div>
      </div>
      {opened && (
        <div className="drivers-section">
          {driversList.map(
            (driver, index) =>
              (driver.vehicle === props.vehicle ||
                driver.IDNO === props.personalFormDetails.nationalId) && (
                <DriverCard
                  handleDriverEdit={handleDriverEdit}
                  handleDriverRemove={handleDriverRemove}
                  driver={driver}
                  key={`DriverCard_${index}`}
                  allowActions={index !== 0}
                  hideDriverEdit={props.hideDriverEdit}
                />
              )
          )}
          <div className="row">
            <div className="col-12">
              {driversList.length < 4 && (
                <Button
                  style={{background: props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT, 
                  borderColor: props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT}}
                  onClick={(e) => setShowAddDriver(true)}
                  icon="pi pi-plus"
                  className="d-flex gap-3 add-driver my-3"
                  label={t("Motor.AddAnotherDriver")}
                />
              )}
            </div>
          </div>
          {showAddDriver && driversList.length < 4 && (
            <>
              <Divider className="mt-2 mb-4" />
              <div className="driver-card form_card">
                <div className="header">
                  <h5>{t("MotorEn.DriverDetails")}</h5>
                  <p>{t("MotorEn.PleaseInformation")}</p>
                </div>
                <Divider />
                <form onSubmit={formik.handleSubmit} className="row">
                  <div className="col-md-5">
                  <div className="field">
                    <span className="p-input-icon-left">
                      <CreditCardIcon color={props.businessColor || globalUtils.BUSINESS_LINE_COLORS.DEFAULT} />
                      <InputText
                        maxLength={10}
                        name="nationalId"
                        value={formik.values.nationalId}
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": isFormFieldValid("nationalId"),
                        })}
                        placeholder={t("PERSONAL_DETAIL.NATIONAL_ID")}
                      />
                    </span>
                    {getFormErrorMessage("nationalId")}
                  </div>
                  </div>
                  
                  <div className="col-md-3">
                  <div className="field">
                    <Dropdown
                      name="yob"
                      className={classNames({
                        "p-invalid": isFormFieldValid("yob"),
                      })}
                      value={formik.values.yob}
                      placeholder={t("PERSONAL_DETAIL.YEAROFBIRTH")}
                      onChange={formik.handleChange}
                      // options={getYobList()}
                      options={globalUtils.getGregYearOfBirthList()}
                      optionLabel="label"
                      optionValue="value"
                      itemTemplate={numbersTemplate}
                      filter
                    />
                    {getFormErrorMessage("yob")}
                  </div>
                  </div>

                  <div className="col-md-3">
                  <div className="field">
                    <Dropdown
                      name="mob"
                      className={classNames({
                        "p-invalid": isFormFieldValid("mob"),
                      })}
                      value={formik.values.mob}
                      placeholder={t("PERSONAL_DETAIL.MONTH_BIRTH")}
                      onChange={formik.handleChange}
                      options={globalUtils.months}
                      optionLabel="label"
                      optionValue="value"
                      itemTemplate={numbersTemplate}
                      filter
                    />
                    {getFormErrorMessage("mob")}
                  </div>
                  </div>
                  
                </form>
                <Divider />
                <div className="actions">
                  <Button
                    onClick={() => setShowAddDriver(false)}
                    className="close-btn p-button-outlined py-1"
                  >
                    {t("MotorEn.Close")}
                  </Button>
                  <Button
                    type="submit"
                    className="save-btn py-1"
                    onClick={() => formik.submitForm()}
                  >
                    {t("Motor.Add")}
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </StyleWrapper>
  );
};

export default Drivers;
